module.exports = __webpack_public_path__ + "img/car800.b0e24a65.png";